import * as React from "react";
import 'intersection-observer';
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { PublicSiteState } from "../../../../public_site.main.mod";
import { decodeHTMLEntities, gtmPush } from "../../../../../helpers";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type FeaturedContentAttributes = {
  blockName: 'vidda/featured-content'
  image_position: 'left' | 'right'
  label: string
  title: string
  intro: string
  image: WordPress.MediaResponse
  button?: ButtonData
  button_2?: ButtonData
  block_width: 'content' | 'big'
}

export interface FeaturedContentInterface {
  blockName: 'vidda/featured-content'
  attrs: FeaturedContentAttributes
}

export type FeaturedContentBlockProps<customBlockData, extra_images> = FeaturedContentAttributes


export function FeaturedContentBlock<customBlockData, extra_images>(
  props: FeaturedContentBlockProps<customBlockData, extra_images>,
  options?: { key?: string }
): (
    s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>
  ) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <section
          className={`block block--featured block--featured${props.image_position == "right" ? "-right" : "-left"} block--${props.block_width}`}
        >
          <div className={`block__inner container container--${props.block_width === 'big' ? 'm' : 's'} gutter--m spacing--m`}>
            <div className="block__content grid--block ls-first-item">
              {props.label && (<span className="block__label typo--s">{props.label}</span>)}
              {props.title && <h2 className="block__title typo--l ff--primary">{decodeHTMLEntities(props.title)}</h2>}
              {props.intro && <div className="block__intro" dangerouslySetInnerHTML={{ __html: props.intro }}></div>}
              {(props.button || props.button_2) && (
                <footer className="block__footer">
                  {props.button && link(linkWrapper({ title: props.button.text, url: props.button.url }),
                    { classname: "button button--primary" },
                    decodeHTMLEntities(props.button.text), 
                    () => {
                      gtmPush({
                        event: 'featured_content_block', 
                        cta_type: 'primary_button', 
                        click_text: props.button.text
                      })
                    }
                  )}
                  {'   '}
                  {props.button_2 && link(linkWrapper({ title: props.button_2.text, url: props.button_2.url }),
                    { classname: "button button--secondary" },
                    decodeHTMLEntities(props.button_2.text), 
                    () => {
                      gtmPush({
                        event: 'featured_content_block', 
                        cta_type: 'secondary_button', 
                        click_text: props.button_2.text
                      })
                    }
                  )}
                </footer>
              )}
            </div>
            {props.image && props.image.media_details && (
              <div className="block__visual ls-second-item">
              {props.block_width === 'big' ?
                <img
                  className="block__image lazyload border-radius--s"
                  src='/frontend/images/empty.png'
                  width={getImageAttribute(props.image, 'featured-s', 'width')}
                  height={getImageAttribute(props.image, 'featured-s', 'height')}
                  alt={props.image.alt_text ? props.image.alt_text : ''}
                  data-sizes="auto"
                  data-src={getImageAttribute(props.image, 'featured-s', 'source_url')}
                  data-srcset={`${getImageAttribute(props.image, 'featured-s', 'source_url')} 560w,
                  ${getImageAttribute(props.image, 'featured-m', 'source_url')} 840w,
                  ${getImageAttribute(props.image, 'featured-l', 'source_url')} 1120w`}
                /> : 
                <img
                  className="block__image lazyload border-radius--s"
                  src='/frontend/images/empty.png'
                  width={getImageAttribute(props.image, 'featured-small', 'width')}
                  height={getImageAttribute(props.image, 'featured-small', 'height')}
                  alt={props.image.alt_text ? props.image.alt_text : ''}
                  data-sizes="auto"
                  data-src={getImageAttribute(props.image, 'featured-small', 'source_url')}
                  data-srcset={`${getImageAttribute(props.image, 'featured-small', 'source_url')} 100vw`}
                />}
              </div>
            )}
          </div>
        </section>
      )
    });
  };
}

